import { render, staticRenderFns } from "./HistorySingo.vue?vue&type=template&id=e5472cae&scoped=true&"
import script from "./HistorySingo.vue?vue&type=script&lang=js&"
export * from "./HistorySingo.vue?vue&type=script&lang=js&"
import style0 from "./HistorySingo.vue?vue&type=style&index=0&id=e5472cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5472cae",
  null
  
)

export default component.exports